module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ornament-prect"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "prect",
    attrs: {
      "id": "illus"
    }
  }, [_c('a', {
    attrs: {
      "id": "pVIII"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate1"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  1 ")]), _vm._v("The imperial family, book plate after Marten van Meytens, 1760. © Schloss Schonbrunn, Vienna, Austria / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate2"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  2 ")]), _vm._v("Marie-Antoinette as dauphine. © Victoria and Albert Museum, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate3"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  3 ")]), _vm._v("Emperor Joseph II and Grand Duke Leopold of Tuscany by Pompeo Giralamo Batoni, 1769, oil on canvas. © Kunsthistorisches Museum, Vienna / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate4"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  4 ")]), _vm._v("Maximilian Francis visiting Marie-Antoinette and Louis XVI, by Joseph Hauzinger, "), _c('i', [_vm._v("c")]), _vm._v(". 1775, oil on canvas. © Kunsthistorisches Museum, Vienna / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate5"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  5 ")]), _vm._v("A gold, enamel and lapis lazuli snuff box, 1776, with a miniature of Provence, Artois and Elizabeth later inset on the base. © Victoria and Albert Museum, London.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate6"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  6 ")]), _vm._v("Madame de Polignac by Elisabeth Vigée-Lebrun, 1782, oil on canvas.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate7"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  7 ")]), _vm._v("The comte de Vaudreuil by Elisabeth Vigée-Lebrun, 1784, oil on canvas. Virginia Museum of Fine Arts.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate8"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  8 ")]), _vm._v("Alex von Fersen, "), _c('i', [_vm._v("c")]), _vm._v(". 1780. Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate9"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("  9 ")]), _vm._v("Marie-Antoinette and her children by Elisabeth Vigée-Lebrun, 1787, oil painting.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate10"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("10 ")]), _vm._v("Benjamin Franklin’s reception at the court of France, 1778, hand-coloured print. ")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate11"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("11 ")]), _vm._v("Charles-Alexandre de Calonne by Elisabeth Vigée-Lebrun, 1784, oil painting. ")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate12"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("12 ")]), _vm._v("A drawing of the necklace of the Diamond Necklace Affair. © Private Collection Archives Charmet / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate13"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("13 ")]), _vm._v("The council room in the king’s private apartments at Versailles. Dennis Jarvis / CC-BY-SA-2.0.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate14"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("14 ")]), _vm._v("Archbishop Loménie de Brienne, principal minister 1787–8, contemporary engraving. G. Garitan / CC-BY-SA-4.0.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "id": "pIX"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate15"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("15 ")]), _vm._v("Mirabeau confronts the king’s Master of Ceremonies by Joseph Court, 23 June 1789, oil painting. © Musée des Beaux Arts, Rouen / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate16"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("16 ")]), _vm._v("The severed heads of three royal officials murdered in July 1789 by Anne-Louis Girodet. Bibliothèque National (IFN-8410751) / Stanford University Libraries.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate17"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("17 ")]), _vm._v("A Bodyguard defends the door to the queen’s bedroom, 6 October 1789 by J. F. Janivel, coloured engraving. © S. Bianchetti / Leemage / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate18"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("18 ")]), _vm._v("Lafayette in the uniform of an American major-general by Charles Wilson Peale, 1780, oil painting. ")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate19"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("19 ")]), _vm._v("Antoine Barnave, eighteenth-century bust. Museum of Grenoble.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate20"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("20 ")]), _vm._v("Joseph Antoine Barnave, 1791, anonymous coloured engraving.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate21"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("21 ")]), _vm._v("Marguerite-Louis-François Duport du Tertre, minister of justice 1790–2, contemporary engraving.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate22"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("22 ")]), _c('i', [_vm._v("The French People Demand the Dethronement of the Tyrant, 10 August 1792")]), _vm._v(" by François Gérard, 1794/95, oil painting. Photograph by Rama, Wikimedia Commons, CC-BY-SA-2.0-fr. ")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate23"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("23 ")]), _c('i', [_vm._v("The Royal Family’s Farewells")]), _vm._v(" by J. B. C. Carbonneau, wood engraving after J. Charterie. Wellcome Foundation / Agefotostock: DAE-BA046873.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate24"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("24 ")]), _vm._v("Marie-Antoinette in the 1750s by Pierre Bouillon. © Musée de la Ville de Paris / Musée Carnavalet, Paris, France / Bridgeman Images.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate25"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("25 ")]), _vm._v("Jacques-Louis David sketches Marie-Antoinette on her way to the guillotine, oil painting by J. E. van der Busche, 1900. Rama / CC-BY-SA-2.0-FR.")])]), _vm._v(" "), _c('p', {
    staticClass: "figlist"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter_7.htm#plate26"
    }
  }, [_c('span', {
    staticClass: "figblock"
  }, [_vm._v("26 ")]), _vm._v("A sketch of Marie-Antoinette on the way to her execution by Jaques-Louis David, 1793. © Private Collection / Bridgeman Images.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9ab528c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list_of_illustrations.vue
// module id = 72
// module chunks = 0